import StartScreen from './components/StartScreen/StartScreen';
import './App.scss';
import { SESSION_STORAGE } from './shared/constants/sessionStorage';
import React, { useState, useEffect, useMemo, JSX } from 'react';
import SolgariLogo from './public/images/solgari-logo.png';
import { LOCAL_STORAGE } from './shared/constants/localStorage';
import SolgariLogoMini from '@/public/icons/solgari-logos/solgari-logo';
import { ForceReload } from './components/ForceReload/ForceReload';
import { useInitDynamicsScripts } from './hooks/useInitDynamicsScripts';
import { useLogin } from './hooks/useLogin';
import { useSessions } from './hooks/useSessions';

export type typeVisible = 'hide' | 'show';

const App = () => {
  const [isStartApp, setIsStartApp] = useState(false);
  const cachedSessionStatus = !!localStorage.getItem(
    LOCAL_STORAGE.LS_SESSION_IS_ACTIVE,
  );
  const [sessionIsActive, setSessionIsActive] = useState(cachedSessionStatus);
  const [contentMode, setContentMode] = useState<string>('default');
  const [warningContent, setWarningContent] = useState<JSX.Element>(<></>);
  const { dynVersion, setDynVersion } = useSessions();
  const currentTabId = useMemo(
    () => `id${Math.random().toString(16).slice(2)}`,
    [],
  );

  useEffect(() => {
    const isSkipStartButton =
      sessionStorage.getItem(SESSION_STORAGE.LS_SKIP_START_BUTTON) === 'true';
    setIsStartApp(isSkipStartButton);

    if (isSkipStartButton) {
      sessionStorage.removeItem(SESSION_STORAGE.LS_SKIP_START_BUTTON);
    }
  }, []);

  const localStorageListener = (event: StorageEvent) => {
    const { key, newValue } = event;
    if (key === LOCAL_STORAGE.LS_SESSION_IS_ACTIVE) {
      setSessionIsActive(!!newValue);
    }
  };

  useEffect(() => {
    window.addEventListener('storage', localStorageListener);
    return () => window.removeEventListener('storage', localStorageListener);
  }, []);

  const startApp = () => {
    localStorage.setItem(LOCAL_STORAGE.LS_TAB_ID_KEY, currentTabId);
    setIsStartApp(true);
  };

  useLogin();

  useInitDynamicsScripts({
    setDynVersion,
    currentTabId,
  });

  const handleWarning = (mode: string, content: JSX.Element) => {
    setContentMode(mode);
    setWarningContent(content);
  };

  if (isStartApp) {
    return <StartScreen dynVersion={dynVersion} />;
  }

  const renderContent = () => {
    switch (contentMode) {
      case 'warning':
        return warningContent;
      default:
        return (
          <>
            <button
              onClick={startApp}
              className="tw-start-button"
              disabled={sessionIsActive}
              data-testid="start-button"
            >
              Start Solgari
            </button>
            <ForceReload
              sendWarning={handleWarning}
              className="force-reload-button"
            />
          </>
        );
    }
  };

  return (
    <>
      <div className="start-wrapper">
        <img src={SolgariLogo} alt="logo" className="start-wrapper__logo" />
        {renderContent()}
      </div>

      <div className="img-wrapper">
        <SolgariLogoMini />
      </div>
    </>
  );
};

export default App;
